import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { EventRecord, eventFromJSON } from "common/records/Event";
import {
  FETCH_EVENT,
  RECEIVE_EVENT,
  RECEIVE_EVENTS,
  EventActions,
  REMOVE_EVENT,
  RESET_EVENT,
} from "common/reducers/event.actions";
import { fetch, receive, reset } from "common/reducers/Utils";
import { reducer as idsManagementReducer } from "common/reducers/idsManagement.reducer";
import { IdsManagementActions } from "common/reducers/idsManagement.actions";

export const EventStateRecord = Record({
  lastSavedById: Map<number, EventRecord>(),
  byId: Map<number, EventRecord>(),
});

export const initialState = EventStateRecord();
export type AppointmentState = typeof initialState;

const model = "events";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case FETCH_EVENT:
      return fetch(state, model, eventFromJSON({ id: action.payload.eventId }));

    case RECEIVE_EVENT:
      return receive(state, model, eventFromJSON(action.payload.event));

    case RECEIVE_EVENTS:
      action.payload.events.forEach((event) => {
        state = reducer(state, EventActions.receiveEvent(event));
      });
      return state;

    case REMOVE_EVENT: {
      state = idsManagementReducer(state, IdsManagementActions.removeId(action.payload.eventId, "events"));
      state = idsManagementReducer(
        state,
        IdsManagementActions.removeId(action.payload.eventId, "globalCalendarEvents"),
      );
      return state
        .deleteIn(["events", "byId", action.payload.eventId])
        .deleteIn(["events", "lastSavedById", action.payload.eventId]);
    }

    case RESET_EVENT:
      return reset(state, model, action.payload.eventId);

    default:
      return state;
  }
};
